import { SEARCH_KIND } from "@/constants";
import { Search as SearchFull, SearchLight } from "@/types/Search";
import { isBefore, startOfDay } from "date-fns";

type Search = SearchFull | SearchLight;

export function groupSearches<T extends Search>(searches: T[]) {
  const inactive: T[] = [];
  const active: T[] = [];
  let saved: T[] = [];

  if (searches?.length) {
    const today = startOfDay(new Date());
    searches
      .filter((a) => a.kind === SEARCH_KIND.REPORT)
      .forEach((a) => {
        if (a.end_date !== null && isBefore(a.end_date, today))
          inactive.push(a);
        else active.push(a);
      });

    saved = searches.filter((a) => a.kind === SEARCH_KIND.SAVED);
  }

  return { saved, active, inactive };
}
